import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnDef } from 'src/app/models/ColumnDef';
import { NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-columns-select-modal',
    templateUrl: './columns-select-modal.component.html',
    styleUrl: './columns-select-modal.component.scss',
    imports: [NgFor, NgIf, FormsModule]
})
export class ColumnsSelectModalComponent {
  @Input() data!: ColumnDef[];
  @Input() name!: string
  
  constructor(public activeModal: NgbActiveModal) {}

  toggle(col: ColumnDef) {
    if (!col.locked) col.visible = !col.visible;
  }

  save() {
    this.activeModal.close(this.data);
  }

  cancel() {
    this.activeModal.dismiss();
  }
}
